module.exports = __webpack_public_path__ + "static/lightning-carousel-hasPreviousNextPanelNavigation-812fe45e7b6e11888ca6c2292e46f4f3.png";